import React, {useContext, useEffect} from 'react';
import {BreadcrumbItem} from '@src/@types/components/Breadcrumbs';
import {useParams} from 'react-router-dom';
import {LayoutContext} from '@src/contexts/LayoutContext';

export default function BreadcrumbsManager(props: {
    pageTitle: string,
    pageBreadcrumbs: BreadcrumbItem[],
    children: React.ReactNode,
}) {
    const {id} = useParams<{ id: string }>();
    const {
        getPageMeta,
        setPageMeta,
        flushPageTitleAndBreadcrumbs
    } = useContext(LayoutContext);
    const {pageTitle, pageBreadcrumbs} = props;

    useEffect(() => {
        setPageMeta({
            pageTitle,
            breadcrumbsItems: [
                ...pageBreadcrumbs.map(item => {
                    if (typeof item.uri === 'object' && !item.uri.params) {
                        item.uri.params = {id: String(id)};
                    }

                    return item;
                }),
            ],
            pageTitlesReplacers: {
                id: String(id),
                number: String(id),
                number_to_display: String(id),
            },
        });

        return () => {
            flushPageTitleAndBreadcrumbs();
        };
    }, [pageBreadcrumbs, getPageMeta, id, pageTitle, flushPageTitleAndBreadcrumbs, setPageMeta]);

    return <>{props.children}</>;
}
